export default __webpack_public_path__ + "static/media/empty_arrow_left.8a246adf.svg";